import { render, staticRenderFns } from "./CandidateSidebarProfileTab.html?vue&type=template&id=4512534f&scoped=true&external"
import script from "./CandidateSidebarProfileTab.js?vue&type=script&lang=js&external"
export * from "./CandidateSidebarProfileTab.js?vue&type=script&lang=js&external"
import style0 from "./CandidateSidebarProfileTab.scss?vue&type=style&index=0&id=4512534f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4512534f",
  null
  
)

export default component.exports